import React, { Component } from 'react'
import { NewButton } from '../shared/NewButton'
import '../stylesheets/inventory.sass'

export default class NoAvailableInventory extends Component {

    render() {
      return (
        <div className={'inventory-welcome-wrapper row'}>
          <div className={'column one'}>
            &nbsp;
          </div>
          <div className={'column two product-welcome'}>
            <div className={'row'}>
              Welcome! It looks like you're new to Kegmeisters.
            </div>
            <div className={'row'}>
              You can't do much in Kegmeisters with out Inventory.
            </div>
            <div className={'new-product-row'}>
              Add products to see inventory here. This inventory is checked in using the Kegmeisters app and is what is available to rent for the next 2 days on the reservation page.
            </div>
            <div className={'new-product-row'}>
              To add inventory now. Check out the Future tab.
            </div>
            <div className={'row'}>
              Questions or Comments? Let’s grab a beer! Or give us a call at (970) 946-5380 or email us at hello@kegmeisters.com we’re happy to help.
            </div>
          </div>
          <div className={'column three'}>
            &nbsp;
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Inventory/NoAvailableInventory.js